const prefix = '_34rFI';

export default prefix;
